import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {AsyncMarkerMap} from '../../common/maps/AsyncMarkerMap';
import {fetchListings} from '../../../actions/listings';
import {fetchListingsSearch} from '../../../actions/listings-search';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';
import {SegmentFilters} from './SegmentFilters';
import {RetryCard} from './RetryCard';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {UNREFINED_KEY} from '../../../utils/listings';
import {AllListingsButtonComponent} from '../../common/listings/AllListingsButton';

import {CardCarousel} from '../../common/carousel/Carousel';
import {GreatPlacesRatioCard} from '../../common/carousel/GreatPlacesCard';

import {SeeMorePropertiesRatioCard} from '../../common/carousel/SeeMorePropertiesCard';
import {isPropertyTypeAll} from '../../../utils/property-types';
import {listingAsPropertyRatioCard} from './Listings';
import {TESTS, getValue} from '../../../utils/abacus';
import {ACTION_LOCATION} from './config';

export function validListing({geoCode, price}) {
    return geoCode.addressLatLngIsValid && price.shortLabel;
}

export function convertListingToMarker(listing) {
    const id = `${listing.id}-${listing.unitUuid}`;

    const position = {
        lat: listing.geoCode.latitude,
        lng: listing.geoCode.longitude
    };

    const showExactLocation = listing.geoCode.showExactLocation;
    const key = listing.id;

    return {
        id,
        position,
        showExactLocation,
        key,
        label: listing.price.shortLabel
    };
}

function onFetchListingsRetry(dispatch, segmentKey, datelessRankingABTest) {
    return () => {
        if (datelessRankingABTest === 1) {
            dispatch(fetchListingsSearch(segmentKey));
        } else {
            dispatch(fetchListings({segmentKey}));
        }
    };
}

export class GreatPlacesToStayComponent extends Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    reloadComponent = () => {
        this.setState({
            hasError: false
        });
    }

    handleNext = () => {
        const edapData = {
            actionlocation: ACTION_LOCATION
        };

        pushEdapEvent('nav.next.click', edapData);
    }

    handlePrev = () => {
        const edapData = {
            actionlocation: ACTION_LOCATION
        };

        pushEdapEvent('nav.previous.click', edapData);
    }

    showMap() {
        const {
            abacus,
            isMobile
        } = this.props;
        return !getValue(abacus, TESTS.MAP_PROPERTIES_REDESIGN_DESKTOP) && !isMobile;
    }

    render() {
        const {
            carouselFocus,
            classNameCta,
            dispatch,
            hideGoogleMap,
            highlightedId,
            inventoryCount,
            isMobile,
            isTablet,
            isRefined,
            lastCardUrl,
            listings = [],
            mapTitle,
            propertyType,
            segmentFilters,
            segmentKey,
            title,
            abacus,
            tripboardComponent,
            aspectRatio = '4x3',
            datelessRankingABTest,
            destinationLocation,
            showNewHeadings
        } = this.props;

        if (listings.length === 0) {
            return null;
        }
        const markers = listings
            .filter(validListing)
            .map(convertListingToMarker);

        const types = getRefinements({propertyType, refinementKey: segmentFilters.key});

        const propertyRatioCards = listings
            .slice(0, 6)
            .map(listingAsPropertyRatioCard({
                dispatch,
                types,
                highlightedId,
                isMobile,
                isTablet,
                tripboardComponent,
                Card: GreatPlacesRatioCard,
                segmentKey
            }));
        propertyRatioCards.push(
            <SeeMorePropertiesRatioCard
                abacus={abacus}
                key={-1}
                lastCardUrl={lastCardUrl}
            />
        );
        const listingsIdIndex = listings
            .map((listing) => listing.id)
            .indexOf(carouselFocus);

        const focusedIndex = listingsIdIndex === -1
            ? null
            : listingsIdIndex;

        const prominentCta = (
            <AllListingsButtonComponent
                {...this.props}
                dispatch={dispatch}
                types={types}
                inventoryCount={inventoryCount}
                className={classNameCta}
                label={mapTitle}
                lastCardUrl={lastCardUrl}
            />
        );

        const refreshComponentCard = <RetryCard onClickHandler={this.reloadComponent} />;

        const fetchRetryCard = (
            <RetryCard onClickHandler={onFetchListingsRetry(dispatch, segmentKey, datelessRankingABTest)} />
        );

        const map = this.state.hasError ? refreshComponentCard : this.showMap() && (
            <div className={`great-places-to-stay__map${isRefined ? ' great-places-to-stay__map__refined' : ''}`}>
                <Fragment>
                    {prominentCta}
                    <AsyncMarkerMap
                        dispatch={dispatch}
                        types={types}
                        segmentKey={segmentKey}
                        inventoryCount={inventoryCount}
                        clickableMarker
                        highlightedId={highlightedId}
                        markers={markers}
                        listings={listings}
                        isLoading={segmentFilters.loading}
                        hasFailed={segmentFilters.failed}
                        apiKey={'AIzaSyAFpxfcM4meoHs0Nt5BX8-bMcY7SEidAPE'}
                        channel={'vrbo-slp'}
                        fallback={fetchRetryCard}
                        destinationLocation={destinationLocation}
                    />
                </Fragment>
            </div>
        );

        const carouselElement = (<div className={'card-carousel'}>
            <CardCarousel
                titleMessage={''}
                focusIndex={focusedIndex}
                aspectRatio={aspectRatio}
                onNextClick={this.handleNext}
                onPreviousClick={this.handlePrev}
            >
                {propertyRatioCards}
            </CardCarousel>
        </div>);

        const carousel = isMobile && segmentFilters.failed ? fetchRetryCard : carouselElement;
        const filters = <div className={'great-places-to-stay__filters'}><SegmentFilters overrideActive={this.state.hasError} filterOverride={segmentKey} /></div>;

        const displayFilters = isPropertyTypeAll(propertyType) ? filters : '';

        return (
            <div className={'container module module--no-padding great-places-to-stay'}>
                <div className={'great-places-to-stay-hd'}>
                    {showNewHeadings
                        ? <h3 className="page-subheading">{title}</h3>
                        : <h2 className={'great-places-to-stay__title'}>{title}</h2>}
                    {displayFilters}
                    {!isRefined && !hideGoogleMap && map}
                </div>
                {carousel}
                {isRefined && !hideGoogleMap && map}
                {isMobile && (prominentCta)}
                <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}} />
            </div>
        );
    }
}

export function mapStateToProps({
    destination,
    abacus,
    greatPlaces,
    config,
    modules
}) {
    const {
        segmentFilters: {key = UNREFINED_KEY},
        segments
    } = destination;
    const isSegment = key !== UNREFINED_KEY && segments.length;
    const inventoryCount = isSegment ?
        segments.find((segment) => segment.messageKey === key).count :
        destination.inventoryCount;

    return {
        listings: destination.listings,
        carouselFocus: greatPlaces.carouselFocus,
        highlightedId: greatPlaces.highlightedId,
        inventoryCount,
        segmentKey: key,
        propertyType: destination.propertyType,
        isMobile: config.isMobile,
        isTablet: config.isTablet,
        isRefined: config.isRefined,
        abacus,
        segmentFilters: destination.segmentFilters,
        serpUrlFilters: destination.serpUrlFilters,
        mapTitle: modules.searchMessages.title,
        title: greatPlaces.title,
        lastCardUrl: destination.lastCardUrl,
        hideGoogleMap: greatPlaces.hideGoogleMap,
        datelessRankingABTest: getValue(abacus, TESTS.DATELESS_RANKING),
        destinationLocation: destination.details.location,
        showNewHeadings: modules.pageHeadings.showNewHeadings
    };
}

export const GreatPlacesToStay = connect(mapStateToProps)(determineIfMobile(GreatPlacesToStayComponent));

GreatPlacesToStay.displayName = 'GreatPlacesToStay';

export default GreatPlacesToStay;
